import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit, OnDestroy {
  public userName: string = "Usuário";
  public profileImg: string = "assets/images/sem-foto.jpg";
  private userDataUpdateListener: any;

  constructor(public router: Router) {
    this.carregarDadosUsuario();
  }

  ngOnInit() {
    // Escutar evento de atualização de dados do usuário
    this.userDataUpdateListener = (event: any) => {
      if (event.detail && event.detail.nome) {
        this.userName = event.detail.nome;
      }
    };

    window.addEventListener("userDataUpdated", this.userDataUpdateListener);
  }

  ngOnDestroy() {
    // Remover listener quando componente for destruído
    if (this.userDataUpdateListener) {
      window.removeEventListener(
        "userDataUpdated",
        this.userDataUpdateListener
      );
    }
  }

  carregarDadosUsuario() {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        this.userName = user.nome || "Usuário";
        this.profileImg = user.img || "assets/images/sem-foto.jpg";
      }
    } catch (error) {
      console.log("Erro ao carregar dados do usuário:", error);
    }
  }

  logoutFunc() {
    // Limpar dados do localStorage
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    this.router.navigateByUrl("/auth/login");
  }
}
